import { useState, useEffect } from 'react';

const POSES = ['presenting', 'pointing', 'thumbsup', 'ok', 'writing', 'folder'];

// A lively lesson header: animated gradient + sheen sweep + drifting gold particles,
// with the mascot auto-cycling through poses (gentle crossfade + hop).
export default function LessonHero({ title, subtitle = "Let's walk through this step together." }) {
  const [idx, setIdx] = useState(0);
  const reduce = typeof window !== 'undefined' && window.matchMedia
    && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  useEffect(() => {
    if (reduce) return;
    const t = setInterval(() => setIdx(i => (i + 1) % POSES.length), 3600);
    return () => clearInterval(t);
  }, [reduce]);

  const particles = Array.from({ length: 9 }, (_, i) => ({
    id: i,
    left: 8 + i * 10 + (i % 2 ? 3 : 0),
    size: 4 + (i % 3) * 3,
    dur: 4 + (i % 4),
    delay: (i * 0.5) % 4,
  }));

  return (
    <div className="lesson-hero" style={{ display: 'flex', alignItems: 'flex-end', gap: 16, borderRadius: 12, padding: '14px 20px', marginBottom: 18, minHeight: 96 }}>
      {!reduce && particles.map(p => (
        <span key={p.id} className="hero-particle"
          style={{ left: p.left + '%', width: p.size, height: p.size, animationDuration: p.dur + 's', animationDelay: p.delay + 's' }} />
      ))}

      <div className="hero-mascot-wrap" style={{ width: 86, height: 96, flexShrink: 0, position: 'relative', zIndex: 1 }}>
        <img key={idx} src={`/mascot/mascot-${POSES[idx]}.png`} alt=""
          className={'hero-mascot' + (reduce ? '' : ' hero-fade-enter')}
          style={{ height: 112, width: 'auto', filter: 'drop-shadow(0 4px 8px rgba(0,0,0,0.25))' }} />
      </div>

      <div style={{ color: '#fff', position: 'relative', zIndex: 1, paddingBottom: 6 }}>
        <div className={reduce ? '' : 'hero-title'} style={{ fontWeight: 800, fontSize: 17 }}>{title}</div>
        <div style={{ fontSize: 13, opacity: 0.88 }}>{subtitle}</div>
      </div>
    </div>
  );
}
